<button
  ftsAsyncButton
  [subscription]='loadingSubscription'
  id='order-notification-upsize-btn'
  class='btn btn-block intro-highlight-bg-color intro-highlight-inverse-text-color shadowed font-secondary text-center wrap-text btn-wrap-text'
  [ngClass]="{'upsell-control': (viewportService?.viewport$ | async)?.isMobile}">
  {{btnLabel}}
</button>
